import * as React from 'react';
import classNames from 'classnames';
import { Col } from '../../grid';
import { CheckFillIcon, CloseFillIcon, LoadingOIcon, WarningFillIcon } from '../../icon';
import ErrorList from './ErrorList';
import { FormContext, FormItemPrefixContext } from './context';
import { traverseChildren } from './util';
const iconMap = {
    success: CheckFillIcon,
    warning: WarningFillIcon,
    error: CloseFillIcon,
    validating: LoadingOIcon
};
/**
 * 将数值携带单位
 * @param val
 * @returns
 */
function withUnit(val) {
    if (typeof val === 'number') {
        return `${val}px`;
    }
    else if (/^\s*\d+\s*$/.test(val)) {
        return `${val.trim()}px`;
    }
    return val;
}
/**
 * 计算 extra 的布局宽度
 * @param horizontalExtraLayout
 * @returns []
 */
function calcExtraLayout(horizontalExtraLayout) {
    let inputWidth = '';
    let extraWidth = ''; // extra 的宽度不做任何设置
    if (Array.isArray(horizontalExtraLayout)) {
        const [iW, eW] = horizontalExtraLayout;
        inputWidth = withUnit(iW);
        if (typeof eW !== 'undefined') {
            extraWidth = withUnit(eW);
        }
    }
    else if (typeof horizontalExtraLayout !== 'undefined') {
        inputWidth = withUnit(horizontalExtraLayout);
        extraWidth = `calc(100% - ${inputWidth})`;
    }
    return [inputWidth, extraWidth];
}
const FormItemInput = props => {
    const { prefixCls, status, wrapperCol, children, help, errors, onDomErrorVisibleChange, hasFeedback, _internalItemRender: formItemRender, validateStatus, extra, horizontalExtra, horizontalExtraLayout, extraWhenFocus } = props;
    const baseClassName = `${prefixCls}-item`;
    const formContext = React.useContext(FormContext);
    const mergedWrapperCol = wrapperCol || formContext.wrapperCol || {};
    const className = classNames(`${baseClassName}-control`, mergedWrapperCol.className);
    React.useEffect(() => () => {
        onDomErrorVisibleChange(false);
    }, []);
    // Should provides additional icon if `hasFeedback`
    const IconNode = validateStatus && iconMap[validateStatus];
    const icon = hasFeedback && IconNode ? (React.createElement("span", { className: `${baseClassName}-children-icon` },
        React.createElement(IconNode, null))) : null;
    // Pass to sub FormItem should not with col info
    const subFormContext = Object.assign({}, formContext);
    delete subFormContext.labelCol;
    delete subFormContext.wrapperCol;
    const extraLayouts = horizontalExtra ? calcExtraLayout(horizontalExtraLayout).map(item => ({ width: item })) : [];
    let propChildren = children;
    const [show, setShow] = React.useState(false);
    if (extraWhenFocus) {
        propChildren = traverseChildren(children, {
            // for extra when focus
            'Input|Password|Search|TextArea|InputNumber|Select': function (child) {
                const { onFocus: _onFocus, onBlur: _onBlur } = child.props;
                return {
                    __binding: true,
                    onFocus: function (e) {
                        setShow(true);
                        if (typeof _onFocus === 'function') {
                            _onFocus(e);
                        }
                    },
                    onBlur: function (e) {
                        setShow(false);
                        if (typeof _onBlur === 'function') {
                            _onBlur(e);
                        }
                    }
                };
            }
        });
        if (propChildren.length === 1) {
            propChildren = propChildren[0];
        }
    }
    const inputDom = (React.createElement("div", { className: `${baseClassName}-control-input`, style: extraLayouts[0] },
        React.createElement("div", { className: `${baseClassName}-control-input-content` }, propChildren),
        icon));
    const errorListDom = (React.createElement(FormItemPrefixContext.Provider, { value: { prefixCls, status } },
        React.createElement(ErrorList, { errors: errors, help: help, onDomErrorVisibleChange: onDomErrorVisibleChange })));
    // If extra = 0, && will goes wrong
    // 0&&error -> 0
    let propExtra = extra;
    if (extraWhenFocus) {
        propExtra = show ? extra : false;
    }
    // 非水平显示 extra + validateStatus 是错误的状态下
    if ((validateStatus === 'warning' || validateStatus === 'error') && propExtra && !horizontalExtra) {
        propExtra = false;
    }
    const extraDom = propExtra ? (React.createElement("div", { className: `${baseClassName}-extra`, style: extraLayouts[1] }, propExtra)) : null;
    const dom = formItemRender && formItemRender.mark === 'pro_table_render' && formItemRender.render ? (formItemRender.render(props, { input: inputDom, errorList: errorListDom, extra: extraDom })) : (React.createElement(React.Fragment, null,
        horizontalExtra ? (React.createElement("div", { className: `${baseClassName}-extra-horizontal` },
            inputDom,
            extraDom)) : (inputDom),
        errorListDom,
        horizontalExtra ? null : extraDom));
    return (React.createElement(FormContext.Provider, { value: subFormContext },
        React.createElement(Col, Object.assign({}, mergedWrapperCol, { className: className }), dom)));
};
export default FormItemInput;
